import http from "@/utils/axios";
import utils from "./common";
export function initWxConfig(circleId,url,wx,) {
  return getTicket(circleId,url,wx);
}

const getTicket = (circleId,url,wx) => {
  return new Promise((resolve, reject) => {
    console.log(`当前页面地址===${url}`)
    // let configUrl = `${location.href.split('?')[0]}`
    // console.log(`当前页面无参数地址===${configUrl}`)
    http({
      url: "order/dmp/ewMassTextingFriendCircle/getAgentConfigByCircleId",
      method: "post",
      parmes:{
        circleId:circleId
      }
    }).then(res => {
      let data = res.data
      console.log(data)
      if (res.code === 200) {
        wx.agentConfig({
          corpid: data.corpId, // 必填，企业微信的corpid，必须与当前登录的企业一致
          agentid: data.agentId, // 必填，企业微信的应用id （e.g. 1000247）
          timestamp: data.timestamp, // 必填，生成签名的时间戳
          nonceStr: data.nonceStr, // 必填，生成签名的随机串
          signature: data.signature,// 必填，签名，见附录-JS-SDK使用权限签名算法
          jsApiList: ['shareToExternalMoments','launchMiniprogram',], //必填，传入需要使用的接口名称
          success: function () {
            console.log('agentConfig注册成功')
            // 回调
            resolve(wx)
          },
          fail: function (res) {
            reject(res)
            if (res.errMsg.indexOf('function not exist') > -1) {
              this.$toast('版本过低请升级')
            }
          }
        });
      }else {
        wx.error(res => {
          reject(res);
          console.log("微信注册失败：" + res);
        })
      }
    }).catch((res) => {
      console.log(res)
    });
  })
}

export function shareToExternalMoments(weixin, content, attachments) {
  return sendMessage(weixin, content, attachments);
}

/**
 * 发送朋友圈
 * @param content 文本内容
 * @param attachments 附件内容
 * {
              msgtype: "image",    // 消息类型，必填
              image: {
                mediaid: "",      // 图片的素材id
                imgUrl: "",        // 图片的imgUrl,跟图片mediaid填其中一个即可
              },
            },
 {
              msgtype: "link",    // 消息类型，必填
              link: {
                title: "",        // H5消息标题
                imgUrl: "",    // H5消息封面图片URL
                url: "",        // H5消息页面url 必填
              },
            },
 {
              msgtype: "video",    // 消息类型，必填
              video:{
                mediaid:"",        // 视频的素材id
              },
            },
 * */
const sendMessage = (weixin, content ,attachments) => {
  return new Promise((resolve, reject) => {
    weixin.invoke("shareToExternalMoments", {
          text: {
            content:content,    // 文本内容
          },
          attachments: attachments
        },(res) => {
            if (res.err_msg == "shareToExternalMoments:ok") {
              resolve()
            }else {
              console.log(`shareToExternalMoments==err:${res.err_msg}`)
              reject(res.err_msg);
            }
          }
    );
  })
}
/**
 * 群统计、群成员统计需求wx.agentConfig 
 * @param {*} url 
 * @param {*} wx 
 * @returns 
 */
export function initWxAgentConfig(url,wx,) {
  let corpId = !utils.isNullData(localStorage.getItem('corpId')) ? localStorage.getItem('corpId') : ''
  let agentId = !utils.isNullData(localStorage.getItem('agentId')) ? localStorage.getItem('agentId') : ''
  let agentType = !utils.isNullData(localStorage.getItem('agentType')) ? localStorage.getItem('agentType') : ''
  return new Promise((resolve, reject) => {
    console.log(`当前页面地址===${url}`)
    let configUrl = `${url.split('?')[0]}`
    console.log(`当前页面无参数地址===${configUrl}`)
    // let type = agentId == '1000002' ? 3 : agentId == '1000003' ? 2 : agentId == '1000004' ? 1 : ''
    let type = agentType
    http({
      url: `order/dmp/dispatch/memberpush/BsEnterpriseWechatGroupChat/getSignature?agentId=${agentId}&corpId=${corpId}&url=${encodeURIComponent(url)}&type=${type}`,
      method: "get",
      parmes:{}
    }).then(res => {
      let data = res.data
      console.log(data)
      if (res.code === 200) {
        wx.agentConfig({
          corpid: data.corpId, // 必填，企业微信的corpid，必须与当前登录的企业一致
          agentid: data.agentId, // 必填，企业微信的应用id （e.g. 1000247）
          timestamp: data.timestamp, // 必填，生成签名的时间戳
          nonceStr: data.nonceStr, // 必填，生成签名的随机串
          signature: data.signature,// 必填，签名，见附录-JS-SDK使用权限签名算法
          jsApiList: ['checkJsApi','getContext','getCurExternalChat','launchMiniprogram'], //必填，传入需要使用的接口名称
          success: function () {
            console.log('agentConfig注册成功')
            // 回调
            resolve(wx)
          },
          fail: function (res) {
            reject(res)
            if (res.errMsg.indexOf('function not exist') > -1) {
              this.$toast('版本过低请升级')
            }
          }
        });
      }else {
        wx.error(res => {
          reject(res);
          console.log("微信注册失败：" + res);
        })
      }
    }).catch((res) => {
      console.log(res)
    });
  })
}
/**
 * H5跳转小程序
 * @param {*} weixin 
 * @param {*} appId 
 * @param {*} path 
 * @returns 
 */
export function launchMiniprogram(weixin, appId, path) {
  return new Promise((resolve, reject) => {
    weixin.checkJsApi({
      jsApiList: ['launchMiniprogram'], // 需要检测的JS接口列表
      success: (res) => {
        console.log(`checkJsApi检测结果`)
        console.log(res)
        // 以键值对的形式返回，可用的api值true，不可用为false
        // 如：{"checkResult":{"chooseImage":true},"errMsg":"checkJsApi:ok"}
        if(res.errMsg == 'checkJsApi:ok'){
          if(res.checkResult.launchMiniprogram){
            weixin.invoke("launchMiniprogram", {
              appid:appId,
              path:path
            },(res) => {
                if (res.err_msg == "launchMiniprogram:ok") {
                  resolve()
                }else {
                  console.log(`launchMiniprogram==err:${res.err_msg}`)
                  reject(res.err_msg);
                }
            });
          }else{
            this.$toast('请升级企业微信至最新版本')
            reject('请升级企业微信至最新版本')
          }
        }else{
          console.log(`checkJsApi==err:${res.errMsg}`)
          reject(res.errMsg)
        }
      }
    });
  })
}
/**
 * 获取进入H5页面的入口类型
 * */
export function getEnterContext(weixin) {
  return new Promise((resolve, reject) => {
    weixin.invoke('getContext', {
    }, function(res){
      if(res.err_msg == "getContext:ok"){
        let entry  = res.entry ; //返回进入H5页面的入口类型，目前有normal、contact_profile、single_chat_tools、group_chat_tools、chat_attachment
        // let shareTicket = res.shareTicket; //可用于调用getShareInfo接口
        console.log(`getContext==ok:${entry}`)
        resolve(entry)
      }else {
        //错误处理
        console.log(`getContext==err:${res.err_msg}`)
        reject(res.err_msg);
      }
    });
  })
}/**
 * 获取当前客户群的群ID
 * */
export function getGroupIdFromOut(weixin) {
  return new Promise((resolve, reject) => {
    weixin.invoke('getCurExternalChat', {
    }, function(res){
      if(res.err_msg == "getCurExternalChat:ok"){
        let chatId  = res.chatId ; //返回当前外部群的群聊ID
        console.log(`getCurExternalChat==ok:${chatId}`)
        resolve(chatId)
      }else {
        //错误处理
        console.log(`getCurExternalChat==err:${res.err_msg}`)
        reject(res.err_msg);
      }
    });
  })
}
